export const headTableCells = [
  { id: 1, property: '', label: '', width: '5%' },
  { id: 2, property: 'Title', label: 'Title', width: '30%' },
  { id: 3, property: 'Line1', label: 'Address', width: '35%' },
  { id: 4, property: 'City', label: 'City', width: '15%' },
  { id: 5, property: 'Province', label: 'Province', width: '15%' },
];
